(ns dre.pages.pubmed-compare.events
  (:require
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.network :as-alias network]
   [dre.utils :refer [stringify-keys-with-namespaces aborted-request?]]
   [dre.utils.query :as utils]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

(def db-path :pubmed-compare)

;;events

(rf/reg-event-fx
 ::init
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} _]
  {:db {:state nil
        :data nil}}))


(rf/reg-event-fx
 ::compare
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [search-query]]
  (let []
    {:db {:state :loading}
     ::network/request-with-abort [{:endpoint :pubmed-compare/compare}
                                   {:body (stringify-keys-with-namespaces (utils/pills-api-params search-query))
                                    :on-success [::success]
                                    :on-failure [::failure]}]})))

(rf/reg-event-fx
 ::success
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [_ [{:keys [::fetch-fx/response]}]]
  {:db {:state :success
        :data (:body response)}}))


(rf/reg-event-fx
 ::failure
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [_ [{:keys [::fetch-fx/response] :as opts}]]
  (if (aborted-request? response)
    {}
    {:db {:state :failure
          :data nil}
     :dispatch-n [[:dre.network/default-failure (merge {:event :pubmed-compare} opts)]]})))


;;subscriptions

(rf/reg-sub
 ::state
 (fn [db _]
   (db-path db)))

(rf/reg-sub
 ::loading?
 :<- [::state]
 (fn [state _]
   (= :loading (get state :state))))

(rf/reg-sub
 ::data
 :<- [::state]
 (fn [state _]
   (get state :data)))